export const REQUEST_SERVICE_UPDATE = '[service] Request Update';
export const SET_SERVICE = '[service] Set Service';

export const REQUEST_VIDEO_ADD = '[service] Request Video Add';
export const VIDEO_ADD = '[service] Video Add';

export const REQUEST_VIDEO_DELETE = '[service] Request Video Delete';
export const VIDEO_DELETE = '[service] Video Delete';

export const REQUEST_VIDEO_REORDER = '[serice] Request Video Reorder';
export const VIDEO_REORDER = '[service] Video Reorder';
